import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';

const API = process.env.REACT_APP_BACKEND_URL;

export default function PersonalTabViewPage() {
  const { shareId } = useParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Redirect to the backend HTML view
    window.location.href = `${API}/api/moms-house/tab-view/${shareId}`;
  }, [shareId]);

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#1e1e2e' }}>
        <p style={{ color: '#94a3b8', fontSize: '16px' }}>Loading tab...</p>
      </div>
    );
  }
  return null;
}
